import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import Fade from "../../../../__snowpack__/pkg/@mui/material/Fade.js";
import React, {useMemo} from "react";
import {TooltipContainer} from "./tooltip.styles.js";
function Tooltip({
  children,
  dataCy,
  translate,
  title = "",
  placement = "right",
  enterDelay = 200,
  leaveDelay = 800
}) {
  const {
    t
  } = useTranslation();
  const _dataCy = useMemo(() => dataCy || translate || title, [dataCy, title, translate]);
  const text = useMemo(() => translate ? t(translate) : title || "", [title, t, translate]);
  return /* @__PURE__ */ React.createElement(TooltipContainer, {
    "data-cy": _dataCy,
    title: text,
    placement,
    TransitionComponent: Fade,
    enterDelay,
    leaveDelay,
    disableFocusListener: true,
    disableInteractive: true,
    disableTouchListener: true,
    arrow: true
  }, /* @__PURE__ */ React.createElement("div", null, children));
}
export default /* @__PURE__ */ React.memo(Tooltip);
